export const UuidRegex = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

export function isUuid(uuid: unknown) {
  return typeof uuid === "string" && UuidRegex.test(uuid);
}
